module.exports = __webpack_public_path__ + "img/FSE_PodcastFestival_LP_Head.0c169747.jpg";